module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new/0114.jpg?v=706d8438";